// extracted by mini-css-extract-plugin
var _1 = "CalendarGridWeekBlockContent-modulelabel__dBR27";
var _2 = "CalendarGridWeekBlockContent-moduletitle__i0qRk CalendarGridWeekBlockContent-modulelabel__dBR27";
export { _1 as "label", _2 as "title" }
